import * as types from './mutation-types'

export const loadProfileSharingData = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/api/businessProfileSharing').then((response) => {
            commit(types.SET_SHARED_PROFILE_USERS, response.data.sharedProfileUsers)
            commit(types.SET_UNSHARED_PROFILE_USERS, response.data.unSharedProfileUsers)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setSelectAllState = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECT_ALL_STATE, data)
}

export const selectAllUsers = ({ commit, dispatch, state }) => {
    if (state.selectedUsers.length === state.unSharingProfileUsers.length) {
        commit(types.SET_SELECTED_USERS, [])
        commit(types.SET_SELECT_ALL_STATE, false)
    } else {
        let allFunderIds = state.unSharingProfileUsers.map(cust => cust.id)
        commit(types.SET_SELECTED_USERS, allFunderIds)
        commit(types.SET_SELECT_ALL_STATE, true)
    }
}

export const selectUser = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECTED_USERS, data)
    if (state.selectedUsers.length === state.unSharingProfileUsers.length) {
        commit(types.SET_SELECT_ALL_STATE, true)
    } else {
        commit(types.SET_SELECT_ALL_STATE, false)
    }
}

export const sharedProfileMultipleUsers = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/businessProfileSharing`, { 'guset_user_ids': state.selectedUsers }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
